import { render, staticRenderFns } from "./dataselector.vue?vue&type=template&id=2c6dc69f&scoped=true"
import script from "./dataselector.vue?vue&type=script&lang=js"
export * from "./dataselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6dc69f",
  null
  
)

export default component.exports